import dadosAgenciaComum from './dadosAgenciaComum';

export const dadosTransamericaPassagens = {
    ...dadosAgenciaComum,
    id: 'transamericapassagens',
    nome: 'Transamérica Passagens',
    instagram: 'instagram.com',
    facebook: 'facebook.com',
    youtube: 'youtube.com',
    email: 'suportevexado@gmail.com',
    idsTagManager: ['GTM-PHGZ336']
};
